import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const MailIconSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3.5" y="5.5" width="17" height="13" rx="2" />
            <path d="m4.25 7 7.75 5.75L19.75 7" />
        </g>
    </svg>
)

const MailIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {MailIconSvg}
    </SvgIcon>
)

export default MailIcon
